<div class="b4a-config-buttons">
    <div class="b4a-flex-left">
        <button id="btnBack" class="b4a-config-btn" [disabled]="changed" (click)="goBack();">{{'tenant.label.btn-back' | translate}}</button>
    </div>
    <div class="b4a-flex-center">
        <button id="btnSave" class="b4a-config-btn" [disabled]="!changed" (click)="save();">{{'tenant.label.btn-save' | translate}}</button>
        <button id="btnCancel" class="b4a-config-btn" [disabled]="!changed" (click)="cancel();">{{'tenant.label.btn-cancel' | translate}}</button>
        <!--
        <button id="btnNew"     class="b4a-config-btn" [disabled]="changed||!id"  (click)="newTenant()">Anlegen</button>
        //-->
    </div>
    <div class="b4a-flex-right">
        <button id="btnLoginAs" class="b4a-config-btn" [disabled]="isAdmin||changed||!id" (click)="loginAs()">{{'tenant.label.btn-login-as' | translate}}</button>
    </div>
</div>

<div class="b4a-config-alert" *ngIf="errMsg!==null">{{errMsg}}</div>

<h1>{{(id===null)?'Neuer Mandant':tenant?.name}}</h1>

<div class="b4a-config-table" *ngIf="tenant||data">
    <!-- display id only for debug
    <div class="b4a-config-row">
        <div class="b4a-config-cell">ID:</div>
        <div class="b4a-config-cell">{{getValue('id')}}</div>
    </div> -->
    <div class="b4a-config-row">
        <div class="b4a-config-cell">{{'tenant.label.code' | translate}}</div>
        <div class="b4a-config-cell">
            <input type="text" class="b4a-config-form-control" [value]="getValue('code')" (input)="setValue('code', $event.target.value)" [ngClass]="{ 'b4a-config-valid': getItem('code').valid===true, 'b4a-config-invalid': getItem('code').valid===false }" />
        </div>
    </div>
    <div class="b4a-config-row">
        <div class="b4a-config-cell">{{'tenant.label.name' | translate}}</div>
        <div class="b4a-config-cell">
            <input type="text" class="b4a-config-form-control" [value]="getValue('name')" (input)="setValue('name', $event.target.value)" [ngClass]="{ 'b4a-config-valid': getItem('name').valid===true, 'b4a-config-invalid': getItem('name').valid===false }" />
        </div>
    </div>
    <div class="b4a-config-row">
        <div class="b4a-config-cell">{{'tenant.label.server-admin' | translate}}</div>
        <div class="b4a-config-cell">
            <!-- change admin-flag is not possible
            <input type="checkbox" [checked]="getValue('admin')" (change)="setValue('admin', $event.target.checked)" />
            //-->
            {{(getValue('admin')===true)?'ja':'nein'}}
        </div>
    </div>
    <div class="b4a-config-row">
        <div class="b4a-config-cell">{{'tenant.label.dev-mode' | translate}}</div>
        <div class="b4a-config-cell">
            <!-- change dev-flag is not possible
            <input type="checkbox" [checked]="getValue('dev')"  (change)="setValue('dev', $event.target.checked)"/>
            //-->
            {{(getValue('dev')===true)?'ja':'nein'}}
        </div>
    </div>
    <div class="b4a-config-row">
        <div class="b4a-config-cell">{{'tenant.label.sales-mode' | translate}}</div>
        <div class="b4a-config-cell"><input type="checkbox" [checked]="getValue('sales')" (change)="setValue('sales', $event.target.checked)" /></div>
    </div>
    <div class="b4a-config-row">
        <div class="b4a-config-cell">{{'tenant.label.archived' | translate}}</div>
        <div class="b4a-config-cell"><input type="checkbox" [checked]="getValue('isArchived')" (change)="setValue('isArchived', $event.target.checked)" /></div>
    </div>
    <div class="b4a-config-row">
        <div class="b4a-config-cell">{{'tenant.label.created' | translate}}</div>
        <div class="b4a-config-cell">{{getValue('creationDatetime')}}</div>
    </div>
    <div class="b4a-config-row">
        <div class="b4a-config-cell">{{'tenant.label.changed' | translate}}</div>
        <div class="b4a-config-cell">{{getValue('changeDatetime')}}</div>
    </div>
    <ng-container *ngIf="id!==null">
        <div class="b4a-config-row">
            <div class="b4a-config-cell">
                <h2>{{'tenant.label.hostname' | translate}}</h2>
            </div>
            <div class="b4a-config-cell"></div>
        </div>
        <ng-container *ngIf="getItem('hostnames')">
            <ng-container *ngFor="let item of getItem('hostnames').childs">
                <div class="b4a-config-row" *ngIf="!item.deleted">
                    <div class="b4a-config-cell b4a-config-lvl1"><a href="https://{{item.apiName}}" target="_blank">{{item.apiName}}</a></div>
                    <div class="b4a-config-cell">
                        <div class="b4a-config-flex">
                            <input type="text" class="b4a-config-form-control" disabled="disabled" [value]="item.value" (input)="setValue(item.path, $event.target.value)" />
                            <button class="b4a-config-btn" (click)="delHostname(item.path)">X</button>
                        </div>
                    </div>
                </div>
            </ng-container>
        </ng-container>
        <ng-container *ngIf="getItem('hostnames?')">
            <ng-container *ngFor="let item of getItem('hostnames?').childs">
                <div *ngIf="!item.deleted" class="b4a-config-row" [ngClass]="{ 'b4a-config-valid': item.valid===true, 'b4a-config-invalid': item.valid===false }">
                    <div class="b4a-config-cell b4a-config-lvl1"><input type="text" class="b4a-config-form-control" [value]="item.apiName" (input)="setKey(item.path, $event.target.value)" /></div>
                    <div class="b4a-config-cell">
                        <div class="b4a-config-flex">
                            <input type="text" class="b4a-config-form-control" [value]="item.value" (input)="setValue(item.path, $event.target.value)" />
                            <button class="b4a-config-btn" (click)="delHostname(item.path)">X</button>
                        </div>
                    </div>
                </div>
            </ng-container>
        </ng-container>
        <div class="b4a-config-row">
            <div class="b4a-config-cell b4a-config-lvl1"><button class="b4a-config-btn" (click)="addHostname()">{{'tenant.label.add' | translate}}</button></div>
            <div class="b4a-config-cell"></div>
        </div>

        <div class="b4a-config-row">
            <div class="b4a-config-cell">
                <h2>{{'tenant.label.parameter' | translate}}</h2>
            </div>
            <div class="b4a-config-cell"></div>
        </div>

        <ng-template #recurseParams let-list>
            <ng-container *ngFor="let item of list">
                <div class="b4a-config-row">
                    <div class="b4a-config-cell b4a-config-lvl{{item.level}}" *ngIf="item.level===1">
                        <h3>{{item.apiName}}</h3>
                    </div>
                    <div class="b4a-config-cell b4a-config-lvl{{item.level}}" *ngIf="item.level>1">{{item.apiName}}</div>
                    <div class="b4a-config-cell" *ngIf="item.hasChildren"></div>
                    <div class="b4a-config-cell" *ngIf="!item.hasChildren">
                        <input type="text" class="b4a-config-form-control" [value]="item.value" (input)="setValue(item.path, $event.target.value)" />
                    </div>
                </div>
                <ng-container *ngIf="item.hasChildren">
                    <ng-container *ngTemplateOutlet="recurseParams; context: { $implicit: item.childs }"></ng-container>
                </ng-container>
            </ng-container>
        </ng-template>
        <ng-container *ngTemplateOutlet="recurseParams; context: { $implicit: getItem('params').childs }"></ng-container>
    </ng-container>
</div>


// WEBPACK FOOTER //
// ./src/app/config/tenant/tenant.component.html